import { React, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosapi from "../api/axiosapi";
import Footer from "../components/Footer";
import useAuth from '../hooks/useAuth';

const GeometricColoringList = () => {
    const navigateto = useNavigate();
    const [geometricColoringList, setGeometricColoringList] = useState([]);
    const [sampleGeometricColoringList, setSampleGeometricColoringList] = useState([]);
    const [err1, setErr1] = useState(false);
    const [err2, setErr2] = useState(false);
    const {auth, setAuth} = useAuth();
    const [loading, setLoading] = useState(true);
    const [openSection, setOpenSection] = useState(null);

    const toggle = (id) => {
        setOpenSection(openSection === id ? null : id);
    };

    useEffect(() => {
        const fetchToken = async () => {
            try {
                const response = await axiosapi.post('/refresh-token', {
                            withCredentials: true
                    });
                setAuth(prev => {
                    return { 
                    ...prev, 
                    userRole1: response.data.userRole1,
                    userRole2: response.data.userRole2,
                    accessToken: response.data.access_token 
                    }
                });
            } catch {
                setAuth(prev => {
                    return { 
                    ...prev, 
                    accessToken: null 
                    }
                }); // 로그인 안 된 상태
            } finally {
                setLoading(false);
            }
        }
        !auth?.accessToken && fetchToken();

        const fetchGeometricColoringList = async () => {
            try {
                const response = await axiosapi.get('/canvascategory/all/');
                setGeometricColoringList(response.data);
            } catch (err) {
                setErr1(true);
                // console.log("err1: ", err);
            }
        }

        const fetchSampleGeometricColoringList = async () => {
            try {
                const response2 = await axiosapi.get('/sample/category/geometriccoloring/');
                setSampleGeometricColoringList(response2.data);
            } catch (err) {
                setErr2(true);
            }
        }

        fetchGeometricColoringList();
        fetchSampleGeometricColoringList();
    }, [])

    if (err1) {
        return (
            <div className="problem">
                <p>"색칠하며 도형 익히기 목록을 다운로드하지 못했습니다. 다시 시도해 주세요."</p>
                <button 
                    className='button'
                    onClick={() => navigateto(-1, {replace: true})}
                >
                    이전화면으로 돌아가기
                </button>
            </div>
        )
    }

    return(
        <div className="vertical-flex-container-1">
            {!err2 && 
                <div className="content-box-1">
                    <div className="section">
                        <div
                            className={`section-bar ${openSection === "색칠하기 샘플" ? "active" : ""}`}
                            onClick={() => toggle("색칠하기 샘플")}
                        >
                            <span>색칠하기 샘플</span>
                            <span className="arrow">▼</span>
                        </div>
    
                        <div className={`card-container ${openSection === "색칠하기 샘플" ? "open" : ""}`}>
                            {sampleGeometricColoringList && sampleGeometricColoringList.map( sampleGeoColor => {
                                return(
                                    <div key={sampleGeoColor.id} className="card">
                                        <h5>{sampleGeoColor.canvasCategoryTitle}</h5>
                                        <Link 
                                            to={`/geometriccoloring/sample/1` }
                                            state={{
                                                "canvasCategoryCode": sampleGeoColor.canvasCategoryCode,
                                                "canvasCode": sampleGeoColor.firstCanvasCode,
                                                "canvasCategoryTitle": sampleGeoColor.canvasCategoryTitle
                                            }}
                                        >
                                            색칠하기
                                        </Link>
                                    </div>
                                )
                            })}
                        </div>
                    </div>

                    {/* <div className="card-list-title">
                        <h4 style={{color:"sienna", fontWeight:"bold"}}>색칠하기 샘플</h4>
                    </div>
                    <div className="card-container">
                        {sampleGeometricColoringList && sampleGeometricColoringList.map( sampleGeoColor => {
                            return(
                                <div key={sampleGeoColor.id} className="card">
                                    <h5>{sampleGeoColor.canvasCategoryTitle}</h5>
                                    <Link 
                                        to={`/geometriccoloring/sample/1` }
                                        state={{
                                            "canvasCategoryCode": sampleGeoColor.canvasCategoryCode,
                                            "canvasCode": sampleGeoColor.firstCanvasCode,
                                            "canvasCategoryTitle": sampleGeoColor.canvasCategoryTitle
                                        }}
                                    >
                                        색칠하기
                                    </Link>
                                </div>
                            )
                        })}
                    </div> */}
                </div>
            }
            <div className="content-box-1">
                <div className="section">
                    <div
                        className={`section-bar ${openSection === "색칠하기" ? "active" : ""}`}
                        onClick={() => toggle("색칠하기")}
                    >
                        <span>색칠하기</span>
                        <span className="arrow">▼</span>
                    </div>

                    <div className={`card-container ${openSection === "색칠하기" ? "open" : ""}`}>
                        {geometricColoringList && geometricColoringList.map( geoColor => {
                            return(
                                <div key={geoColor.id} className="card">
                                    <h5>{geoColor.canvasCategoryTitle}</h5>
                                    <Link 
                                        to={`/geometriccoloring/1` }
                                        state={{
                                            "canvasCategoryCode": geoColor.canvasCategoryCode,
                                            "canvasCode": geoColor.firstCanvasCode,
                                            "canvasCategoryTitle": geoColor.canvasCategoryTitle
                                        }}
                                    >
                                        색칠하기
                                    </Link>
                                </div>
                            )
                        })}
                    </div>
                </div>

                {/* <div className="card-list-title">
                    <h4 style={{color:"sienna", fontWeight:"bold"}}>색칠하기</h4>
                </div>
                <div className="card-container">
                            {geometricColoringList.map(geoColor => {
                                return (
                                    <div key={geoColor.id} className="card">
                                        <h4>{geoColor.canvasCategoryTitle}</h4>
                                        <Link 
                                            to={`/geometriccoloring/1`}
                                            state={{
                                                "canvasCategoryCode": geoColor.canvasCategoryCode,
                                                "canvasCategoryTitle": geoColor.canvasCategoryTitle,
                                                "canvasCode":geoColor.firstCanvasCode
                                            }}
                                        >
                                            색칠하기
                                        </Link>
                                    </div>
                                )
                            })}
                </div> */}
            </div>
            <div style={{width: "100%"}}>
                <Footer/>
            </div>
        </div>
    );
}

export default GeometricColoringList;